import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";
import ChangeAttendanceTable from "./table/ChangeAttendanceTable.vue";
import ChangeShiftTable from "./table/ChangeShiftTable.vue";
import OvertimeWorkTable from "./table/OvertimeWorkTable.vue";
import VacationTable from "./table/VacationTable.vue";
import ApprovalStatus from "@/views/ApprovalStatus.vue";
import { useApproval } from "@/composable/Approval";
import ShiftSearch from "./shift/ShiftSearch.vue";
import EarlytimeTable from "./table/EarlytimeTable.vue";

type ApprovalIndex = typeof ApprovalIndex[keyof typeof ApprovalIndex];
type Props = {
  value?: number;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'ApprovalView',
  props: {
    value: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { value: number };

const ApprovalIndex = {
  WorkSchedule: 0,
  Vacation: 1,
  Shift: 2,
  Overwork: 3,
  Attendance: 4,
  Earlytime: 5
} as const;
const tabItems = [
  { text: "勤務表", component: ApprovalStatus },
  { text: "休暇", component: VacationTable },
  { text: "シフト", component: ChangeShiftTable },
  { text: "残業", component: OvertimeWorkTable },
  { text: "勤務時間変更", component: ChangeAttendanceTable },
  { text: "早出", component: EarlytimeTable },
  { text: " シフト表", component: ShiftSearch }
] as const;

const approval = useApproval();

const items = [
  {
    text: "勤務表",
    component: ApprovalStatus,
    index: ApprovalIndex.WorkSchedule
  },
  { text: "休暇", component: VacationTable, index: ApprovalIndex.Vacation },
  { text: "シフト", component: ChangeShiftTable, index: ApprovalIndex.Shift },
  { text: "残業", component: OvertimeWorkTable, index: ApprovalIndex.Overwork },
  {
    text: "勤務時間変更",
    component: ChangeAttendanceTable,
    index: ApprovalIndex.Attendance
  },
  {
    text: "早出",
    component: EarlytimeTable,
    index: ApprovalIndex.Earlytime
  }
];



const tabs = ref(props.value);

watch(tabs, () => {
  console.warn("awthc");
  approval.resetForm();
});

return { __sfc: true,ApprovalIndex, tabItems, approval, items, props, tabs }
}

})